import React, { FunctionComponent, ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './commonButton.module.css';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  modifier?: string;
  arrow?: boolean;
  white?: boolean;
  size?: 'small' | 'medium' | 'large' | undefined;
  qaTag?: string;
  disabled?: boolean;
  link?: boolean;
  stylesModifier?: string;
}

export const CommonButton: FunctionComponent<ButtonProps> = ({
  modifier = '',
  arrow,
  white,
  size,
  children,
  disabled,
  qaTag = 'common-button',
  link = false,
  stylesModifier,
  ...props
}) => {
  const classList = classNames({
    [styles.button]: true,
    'lp-button': true,
    [styles.arrow]: arrow,
    [styles.white]: white,
    [styles.size]: size,
    [modifier]: modifier,
    [styles[stylesModifier]]: stylesModifier,
    [styles.disabled]: disabled,
    [styles.link]: link,
  });

  return (
    <button {...props} className={classList} disabled={disabled} data-qat={qaTag}>
      {children}
    </button>
  );
};
